import React from 'react';

import introTitle from "../assets/images/Tittle_Instrucciones.png";
import iconStep1 from "../assets/images/Icon_1.png";
import iconStep2 from "../assets/images/Icon_2.png";
import iconStep3 from "../assets/images/Icon_3.png";

import iconKeyA from "../assets/images/Key_A.png";
import iconKeyAL from "../assets/images/Key_Left.png";

import iconKeyD from "../assets/images/Key_D.png";
import iconKeyAR from "../assets/images/Key_Right.png";

import iconKeyS from "../assets/images/Key_S.png";
import iconKeyAD from "../assets/images/Key_Down.png";

import iconKeySpace from "../assets/images/Key_Space.png";

import iconPhone from "../assets/images/Icon_Phone.png";
import iconCharacter from "../assets/images/NPC_Tutorial.png";
import iconCoins from "../assets/images/Coin_Tutorial.png";

import useScreenOrientation from './helpers/useScreenOrientation';

export default function Instructions({ isVisible, setView, isGameLoaded, setPlayGame}: any) {

  const isLandscape = useScreenOrientation();

  return (
    <div className={`full-instructions-container ${isVisible === true ? 'active' : 'hidden'}`}>
      {isLandscape === true ?
        <div className='instructions-landscape-container'>
        <img className='instructions-landscape-container-header' src={introTitle} alt=''/>

        <div className='instructions-landscape-container-items-horizontal'>
          {/* STEP 1 */}
          <div className='instructions-landscape-container-step1'>

            <div className='instructions-landscape-container-step1-icon'>
              <img className='instructions-landscape-container-step1-icon-img' src={iconStep1} alt=''/>
            </div>

            <div className='instructions-landscape-container-step1-content'>
              <div className='instructions-landscape-container-step1-line'>
                <img className='instructions-landscape-container-step1-line-img' src={iconKeyA} alt=''/>
                <img className='instructions-landscape-container-step1-line-img' src={iconKeyAL} alt=''/>  
                <div className='instructions-landscape-container-step1-line-text'>
                  Ir a la izquierda
                </div>
              </div>
              <div className='instructions-landscape-container-step1-line'>
                <img className='instructions-landscape-container-step1-line-img' src={iconKeyD} alt=''/>  
                <img className='instructions-landscape-container-step1-line-img' src={iconKeyAR} alt=''/>  
                <div className='instructions-landscape-container-step1-line-text'>
                  Ir a la derecha
                </div>
              </div>
              <div className='instructions-landscape-container-step1-line'>
                <img className='instructions-landscape-container-step1-line-img' src={iconKeyS} alt=''/>  
                <img className='instructions-landscape-container-step1-line-img' src={iconKeyAD} alt=''/>  
                <div className='instructions-landscape-container-step1-line-text'>
                  Agacharse
                </div>
              </div>
              <div className='instructions-landscape-container-step1-line'>
                <img className='instructions-landscape-container-step1-line-imgx2' src={iconKeySpace} alt=''/>  
                <div className='instructions-landscape-container-step1-line-text'>
                  Saltar
                </div>
              </div>
            
            </div>

          </div>
          <hr className='instructions-landscape-container-separator'/>
          {/* STEP 2 */}
          <div className='instructions-landscape-container-step2'>

            <div className='instructions-landscape-container-step2-icon'>
              <img className='instructions-landscape-container-step2-icon-img' src={iconStep2} alt=''/>  
            </div>

            <div className='instructions-landscape-container-step2-line-text'>
              Desplázate de lado a lado para esquivar los obstáculos, de lo contrario perderás vidas.
            </div>
            <img className='instructions-landscape-container-step2-line-img' src={iconCharacter} alt=''/>  

          </div>
          <hr className='instructions-landscape-container-separator'/>
          {/* STEP 3 */}
          <div className='instructions-landscape-container-step2'>

            <div className='instructions-landscape-container-step2-icon'>
              <img className='instructions-landscape-container-step2-icon-img' src={iconStep3} alt=''/>  
            </div>

            <div className='instructions-landscape-container-step2-line-text'>
              Recolecta monedas. Tendrán diferente puntaje dependiendo de su tamaño.
            </div>
            <img className='instructions-landscape-container-step2-line-img' src={iconCoins} alt=''/>  

          </div>

        </div>
        
        <div className={`instructions-landscape-send-button ${(isGameLoaded) ? '' : 'error'}`} onClick={() => { if (isGameLoaded === true) {setView("SceneUI"); setPlayGame(true)} }}>
          <div className='instructions-landscape-send-button-text'>{isGameLoaded ? `Continuar` : `Cargando`}</div>
        </div>

      </div>
        :
        <div className='instructions-portrait-container'>
          <img className='instructions-portrait-container-header' src={introTitle} alt=''/>

          <div className='instructions-portrait-container-step'>
            <div className='instructions-portrait-container-step-icon'>
              <img className='instructions-portrait-container-step-icon-img' src={iconStep1} alt=''/>
            </div>
            <div className='instructions-portrait-container-items-vertical'>
              <div className='instructions-portrait-container-items-horizontal'>
                <img className='instructions-portrait-container-step-item-img' src={iconPhone} alt=''/>
                <div className='instructions-portrait-container-step-item-text'>
                  <p>1. Ir a la Izquierda</p>
                  <p>2. Ir a la derecha</p>
                  <p>3. Saltar</p>
                  <p>4. Agacharse</p>
                </div>
              </div>
              <div className='instructions-portrait-container-items-horizontal'>
                <img className='instructions-portrait-container-step-item-img' src={iconCharacter} alt=''/>
                <div className='instructions-portrait-container-step-item-text'>
                  Esquivar los obstáculos o perderás vidas.
                </div>
              </div>

            </div>

          </div>

          <div className='instructions-portrait-container-step'>
            <div className='instructions-portrait-container-step-icon'>
              <img className='instructions-portrait-container-step-icon-img' src={iconStep2} alt=''/>
            </div>

            <div className='instructions-portrait-container-items-vertical'>
              <div className='instructions-portrait-container-items-horizontal'>
                <img className='instructions-portrait-container-step-item-img' src={iconCoins} alt=''/>
                <div className='instructions-portrait-container-step-item-text'>
                  Recolecta monedas. Tendrán diferente puntaje dependiendo de su tamaño.
                </div>
              </div>
            </div>

          </div>
          
          <div className={`instructions-portrait-send-button ${(isGameLoaded) ? '' : 'error'}`} onClick={() => { if (isGameLoaded === true) {setView("SceneUI"); setPlayGame(true)} }}>
            <div className='instructions-portrait-send-button-text'>{isGameLoaded === true ? 'Continuar' : 'Cargando'}</div>
          </div>

        </div>
      }
    </div>
  );
}